import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SessionProvider } from './services/sessionContext'; // Importa el SessionProvider
import { BrowserRouter as Router } from 'react-router-dom'; // Importa Router

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <SessionProvider> {/* Envuelve tu aplicación en SessionProvider */}
        <App />
      </SessionProvider>
  </React.StrictMode>
);

reportWebVitals();
